import { Button, Form, Input, InputNumber, Select, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { FormListFieldData } from 'antd/es/form/FormList';
import { DeleteIcon } from 'components/common/Icons';
import { intermediaryFeesQuestions } from 'pages/ApplicationFormPage/IntermediaryFees/questions';
import { HowPayable, WhenPayable } from 'pages/ApplicationFormPage/IntermediaryFees/types';
import { useIntl } from 'react-intl';

const defaultFeeRecord = {
  description: '',
  whenPayable: WhenPayable.ON_APPLICAION,
  howPayable: HowPayable.PAID_DIRECT_TO_BROKER,
};

export function IntermediaryFeesEditableTable() {
  const { formatMessage } = useIntl();
  const { whenPayable, howPayable } = intermediaryFeesQuestions.fees;
  const requiredFieldMessage = formatMessage({ id: 'common.error.requiredField' });

  return (
    <Form.List name='fees'>
      {(fields, { add, remove }) => {
        const columns: ColumnsType<FormListFieldData> = [
          {
            title: formatMessage({ id: intermediaryFeesQuestions.fees.description.labelKey }),
            key: 'description',
            render: (_, field) => (
              <>
                <Form.Item name={[field.name, 'id']} hidden noStyle>
                  <Input />
                </Form.Item>
                <Form.Item
                  name={[field.name, 'description']}
                  rules={[{ required: true, message: requiredFieldMessage }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input />
                </Form.Item>
              </>
            ),
          },
          {
            title: formatMessage({ id: intermediaryFeesQuestions.fees.amount.labelKey }),
            key: 'amount',
            render: (_, field) => (
              <Form.Item
                name={[field.name, 'amount']}
                rules={[{ required: true, message: requiredFieldMessage }]}
                style={{ marginBottom: 0 }}
              >
                <InputNumber prefix='£' precision={0} min={0} style={{ width: '100%' }} />
              </Form.Item>
            ),
          },
          {
            title: formatMessage({ id: intermediaryFeesQuestions.fees.whenPayable.labelKey }),
            key: 'whenPayable',
            render: (_, field) => (
              <Form.Item
                name={[field.name, 'whenPayable']}
                rules={[{ required: true, message: requiredFieldMessage }]}
                style={{ marginBottom: 0 }}
              >
                <Select options={whenPayable.options} />
              </Form.Item>
            ),
          },
          {
            title: formatMessage({ id: intermediaryFeesQuestions.fees.howPayable.labelKey }),
            key: 'howPayable',
            render: (_, field) => (
              <Form.Item
                name={[field.name, 'howPayable']}
                rules={[{ required: true, message: requiredFieldMessage }]}
                style={{ marginBottom: 0 }}
              >
                <Select options={howPayable.options} />
              </Form.Item>
            ),
          },
          {
            title: formatMessage({ id: intermediaryFeesQuestions.fees.refundableAmount.labelKey }),
            key: 'refundableAmount',
            render: (_, field) => (
              <Form.Item
                name={[field.name, 'refundableAmount']}
                rules={[{ required: true, message: requiredFieldMessage }]}
                style={{ marginBottom: 0 }}
              >
                <InputNumber prefix='£' precision={0} min={0} style={{ width: '100%' }} />
              </Form.Item>
            ),
          },
          {
            key: 'actions',
            width: 48,
            render: (_, field) => (
              <a onClick={() => remove(field.name)}>
                <DeleteIcon
                  titleAccess={formatMessage({
                    id: 'applicationForm.INTERMEDIARY_FEES.fees.delete.columnLabel',
                  })}
                />
              </a>
            ),
          },
        ];

        return (
          <>
            <Table
              columns={columns}
              dataSource={fields}
              pagination={false}
              rowKey='key'
              size='middle'
              className='mt-4'
            />
            <Button type='dashed' onClick={() => add(defaultFeeRecord)} className='mt-4'>
              {formatMessage({ id: 'applicationForm.INTERMEDIARY_FEES.fees.add.button' })}
            </Button>
          </>
        );
      }}
    </Form.List>
  );
}
